<template>
  <div>
    <PageTitle title="Quotations" :btnCreate="false" />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="show">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="['search', 'shop', 'customer', 'dateRange', 'biller']"
              v-model="filter"
              :columns="columns"
            ></TableFilters>
          </v-row>
        </v-card>
      </v-expand-transition>

      <v-card class="lighten-12 card-content mt-0 pa-3">
        <v-col
          class="pr-1 text-right"
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          xl="2"
        >
        </v-col>
        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="quotationDatas"
          class="row-pointer"
          item-key="id"
          hide-default-footer
          style="
            font-weight: normal;
            font-family: 'Source Sans Pro', sans-serif;
          "
        >
          <template v-slot:no-data>
            <noData
              class="mt-10 container justify-center item-center"
              name="shop"
            />
          </template>
          <!-- No -->
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="quotations"
              :item="item"
              refreshData
              viewPermission="Expense Show"
              :isEditModal="false"
            ></list-menu>
          </template>

          <template v-slot:footer>
            <pagination
              url="pos/quotations"
              @paginationOptions="setPaginationOptions"
              @getPageNumber="setPagenumber"
              :filterAction="true"
              @responseData="receiveQuotationData"
              :filter="filter"
              ref="pagination"
            />
          </template>
          <template v-slot:item.date="{ item }">
            <div>
              {{ item.date | formatDate }}
            </div>
          </template>
          <template v-slot:item.reference_number="{ item }">
            <div>
              {{ item.reference_number }}
            </div>
          </template>
          <template v-slot:item.customer="{ item }">
            <div>
              {{ item.customer ? item.customer.name : '...' }}
            </div>
          </template>
          <template v-slot:item.shop="{ item }">
            <div>
              {{ item.shop ? item.shop.name : '...' }}
            </div>
          </template>
          <template v-slot:item.biller="{ item }">
            <div>
              {{ item.biller ? item.biller.first_name : '...' }}
            </div>
          </template>
          <template v-slot:item.total="{ item }">
            <div>
              {{ item.total | formatCurrency }}
            </div>
          </template>
          <template v-slot:item.discount="{ item }">
            <div>
              {{ item.discount | formatCurrency }}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TableFilters from '@/components/base/TableFilters';
import pagination from '../shared/components/pagination';
import noData from '../../components/shared/noItem';

export default {
  data: () => ({
    isLoading: false,
    paginationOptions: {},
    show: false,
    pagination1: {
      descending: true,
      page: 1,
      total: 0,
      rowsPerPage: 2,
      sortBy: 'fat',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
      },
      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
      },
      {
        text: 'Customer',
        value: 'customer',
        show: true,
        disabled: false,
      },
      {
        text: 'Shop',
        value: 'shop',
        show: true,
        disabled: false,
      },
      {
        text: 'Biller',
        value: 'biller',
        show: true,
        disabled: false,
      },
      {
        text: 'Total',
        value: 'total',
        show: true,
        align: 'right',
        disabled: false,
      },
      {
        text: 'Discount',
        value: 'discount',
        show: true,
        align: 'right',
        disabled: false,
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    quotationDatas: [],

    filter: {
      start: '',
      end: '',
      biller: '',
      customer: '',
      shop: '',
    },
  }),
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  components: {
    pagination,
    TableFilters,
    noData,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    receiveQuotationData(data) {
      this.quotationDatas = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
